import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Soodushind kehtib püsiklientidele. Täpne soodustus sõltub kliendikontol oleva summa suurusest.

  <span style="color:#85c1dc;">**FI:**</span>
  Tarjoushinta on voimassa ON24-siakkaille. Tarkka alennus riippuu ON24-asiakastilin saldosta.

  <span style="color:#85c1dc;">**RU:**</span>
  Льготная цена действует для постоянных клиентов. Точная скидка зависит от суммы на счете клиента.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1316 = msg(
  mf`Soodushind kehtib püsiklientidele. Täpne soodustus sõltub kliendikontol oleva summa suurusest.`,
  mf`Tarjoushinta on voimassa ON24-siakkaille. Tarkka alennus riippuu ON24-asiakastilin saldosta.`,
  mf`Льготная цена действует для постоянных клиентов. Точная скидка зависит от суммы на счете клиента.`,
)

export { m1316 as 'w.module.product.prices_tooltiploggedout' }